import DisqualificationForm from './DisqualificationForm';

export default DisqualificationForm;
